module.exports = __webpack_public_path__ + "media/images/common/2column_product_bg_ynn-f79fe261d12c3a2cbda6ee0e16da0c92.png";